export default function(instance){
    return{
        updateMP(){
            return instance.get('/Update/UpdateMP')
        },
    }
}
